import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hasPermission' })

export class HasPermissionPipe implements PipeTransform {
  transform(permissions: string[], required: string[]): boolean {
    return required.some((p: string): boolean => permissions?.includes(p));
  }
}
